import ContentCard from "../../../Components/ContentCard";
import PDFPageRotate from "../../../Components/PDFPageRotate";
import { Helmet } from "react-helmet-async";

const Rotate = () => {
    return (
        <>
            <Helmet>
                <title>PDF Seiten drehen – kostenlos online | FileForge</title>
                <meta name="description" content="Drehen Sie einzelne oder alle Seiten Ihrer PDF-Dateien – kostenlos, ohne Anmeldung, direkt im Browser." />
                <link rel="canonical" href="https://www.file-forge.org/pdf-seiten-drehen" />
            </Helmet>

            <ContentCard
                title="Seiten drehen"
                description="Drehen Sie die Seiten Ihrer PDF-Dateien."
                baseClases="p-6 m-2 border flex flex-col gap-4 w-full"
            >
                <PDFPageRotate />
            </ContentCard>
        </>
    )
}

export default Rotate